module.exports = __webpack_public_path__ + "img/LV5.a87e477b.png";